import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import { AppErrorBoundary } from './components/errors/AppErrorBoundary';
import { installChunkLoadRecovery } from './lib/chunkLoadRecovery';
import './index.css';

/**
 * Correctif de la page blanche du tunnel de réservation.
 *
 * <p>Deux protections installées AVANT le rendu :
 *
 *  1. `installChunkLoadRecovery()` : un chunk `lazy` introuvable (build obsolète après un
 *     déploiement) déclenche un rechargement unique au lieu de laisser un écran vide.
 *  2. `AppErrorBoundary` : toute erreur de rendu restante affiche un écran lisible avec un
 *     bouton de rechargement, au lieu de démonter l'arbre React en silence.
 *
 * <p>Sans ces deux garde-fous, le moindre échec de chargement produisait une page blanche
 * muette — c'est le défaut signalé sur « Prendre rendez-vous ».
 */
installChunkLoadRecovery();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);

